import { Card, ReadOnlySection, Divider } from '@cxc/react-fpds-components';
import styles from './FundingPanel.module.scss';
import TabSectionProps from '../../../types/props/TabSectionProps';
import {
    CardType,
    ReadOnlySectionItemType,
    ReadOnlySectionType,
} from '../../../types/TabSectionTypes';
import { TITLE, SUBTITLES } from '../../../constants/FundingPanelConstants';

export const FundingPanel = ({ incentive }: TabSectionProps) => {
    const fundingCardElements: ReadOnlySectionType[] = [
        {
            title: TITLE,
            columnOptions: { xl: 4, l: 4, m: 12, s: 12 },
            items: [
                { title: SUBTITLES.TOTAL_FUNDING, content: incentive.totalFunding.toString() },
                { title: SUBTITLES.CURRENT_FUNDING, content: incentive.currentFunding.toString() },
                { title: '', content: '' },
            ],
        },
        {
            title: '',
            columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
            items: [
                {
                    title: SUBTITLES.FUNDING_SITUATION_DESCRIPTION,
                    content: incentive.fundingSituationDescription,
                },
            ],
        },
        {
            title: '',
            columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
            items: [
                {
                    title: SUBTITLES.METHODOLOGY_DESCRIPTION,
                    content: incentive.methodologyDescription,
                },
            ],
        },
        {
            title: '',
            columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
            items: [
                {
                    title: SUBTITLES.FUNDING_CAP_PER_PROJECT,
                    content: incentive.fundingCapPerProject,
                },
            ],
        },
        {
            title: '',
            columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
            items: [
                {
                    title: SUBTITLES.FUNDING_CAP_PER_APPLICANT,
                    content: incentive.fundingCapPerApplicant.toString(),
                },
            ],
        },
    ];

    const cards: CardType[] = [{ title: '', content: fundingCardElements }];

    return (
        <div
            style={{
                height: 'calc(100vh - [footer-height]px)',
                overflowY: 'auto',
            }}
        >
            {cards.map((card: CardType) => (
                <Card className={styles.fundingCard} key={card.title}>
                    {card.content.map((element: ReadOnlySectionType, index) => (
                        <div key={index}>
                            <ReadOnlySection
                                header={{
                                    title: element.title,
                                }}
                                columnOptions={element.columnOptions}
                                className="read-only-section"
                                variant="SuperCondensed"
                            >
                                {element.items.map((item: ReadOnlySectionItemType) => (
                                    <ReadOnlySection.Item
                                        key={item.title}
                                        label={item.title}
                                        // @ts-expect-error - Need to pass in Link Element therefore JSX is mandatory here
                                        value={item.content}
                                    />
                                ))}
                            </ReadOnlySection>
                            {card.content.length - 1 !== index && (
                                <Divider style={{ marginTop: '24px' }} />
                            )}
                        </div>
                    ))}
                </Card>
            ))}
        </div>
    );
};
